import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from '../../../environment';

import { Production } from '../models/production.model';

@Injectable({
  providedIn: 'root',
})
export class ProductionReportService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/herd/secure/report/production';

  getList(): Observable<Production[]> {
    return this.http.get<Production[]>(`${this.baseUrl}`);
  }
}
